import React , {useState} from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import { Type } from "lucide-react"

import {Box, useTheme, useMediaQuery} from "@mui/material";

const FontSize = ({ fontSize, setFontSize}) => {
    const [isIncreaseButtonClicked, setIsIncreaseButtonClicked] = useState(false);
    const [isDecreaseButtonClicked, setIsDecreaseButtonClicked] = useState(false);

    const handleIncreaseFontSizeButtonBlur = () => {
        setIsIncreaseButtonClicked(false);
    }
    const handleDecreaseFontSizeButtonBlur = () => {
        setIsDecreaseButtonClicked(false);
    }
    const handleDecreaseFontSizeButtonClick = () => {
        setIsDecreaseButtonClicked(true);
        setFontSize(prevFontSize => prevFontSize - 0.5);
    }
    const handleIncreaseFontSizeButtonClick = () => {
        setIsIncreaseButtonClicked(true);
        setFontSize(prevFontSize => prevFontSize + 0.5);
    }
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span>
                <IconButton
                    variant="outlined"
                    size={isMobile ? "small" : "medium"}
                    sx={{
                        height: { xs: 28, sm: 32 },
                        width: { xs: 28, sm: 32 },
                        fontSize: { xs: "0.75rem", sm: "0.8rem" },
                        color: "#616161",
                        border: "1px solid #d8d6d6",
                        borderRadius:"5px",
                        p:0.7,
                        "&:hover": {
                            borderColor: "#757575",
                            background: "#F5F5F5",
                        },
                    }}
                    onClick={handleIncreaseFontSizeButtonClick}
                    onBlur={handleIncreaseFontSizeButtonBlur}
                >
                    <Type size={isMobile ? 14 : 16} />
                    +
                </IconButton>
            </span>
            <span>
                <IconButton
                    variant="outlined"
                    size={isMobile ? "small" : "medium"}
                    sx={{
                        height: { xs: 28, sm: 32 },
                        width: { xs: 28, sm: 32 },
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        color: "#616161",
                        border: "1px solid #d8d6d6",
                        borderRadius:"5px",
                        p:1,
                        "&:hover": {
                            borderColor: "#757575",
                            background: "#F5F5F5",
                        },
                    }}

                    onClick={handleDecreaseFontSizeButtonClick}
                    onBlur={handleDecreaseFontSizeButtonBlur}
                >
                    <Type size={isMobile ? 14 : 16} />
                    -
                </IconButton>
            </span>
        </Box>
    );
}
FontSize.propTypes = {
    fontSize: PropTypes.number,
    setFontSize: PropTypes.func,
};
export default FontSize;